const ACTIONS = {
  FETCH_GITHUB_RUNNERS: 'fetch-github-runners',
  FETCH_GITHUB_PAGE_RUNNERS: 'fetch-github-page-runners',
  SEND_GITHUB_RUNNERS: 'send-github-runners',
};

export default ACTIONS;
